namespace Vit.Administration {
    export interface TenantRow {
        TenantId?: number;
        ParentTenantId?: number;
        TenantName?: string;
        Tenant_ParentTenantId?: TenantRow[];
        ParentTenantParentTenantId?: number;
        ParentTenantTenantName?: string;
    }

    export namespace TenantRow {
        export const idProperty = 'TenantId';
        export const nameProperty = 'TenantName';
        export const localTextPrefix = 'Administration.Tenant';
        export const lookupKey = 'Administration.Tenant';

        export function getLookup(): Q.Lookup<TenantRow> {
            return Q.getLookup<TenantRow>('Administration.Tenant');
        }

        export declare const enum Fields {
            TenantId = "TenantId",
            ParentTenantId = "ParentTenantId",
            TenantName = "TenantName",
            Tenant_ParentTenantId = "Tenant_ParentTenantId",
            ParentTenantParentTenantId = "ParentTenantParentTenantId",
            ParentTenantTenantName = "ParentTenantTenantName"
        }
    }
}
